var map = {
	"./404.svg": [
		61753,
		1753
	],
	"./academic-cap.svg": [
		87029,
		7029
	],
	"./adjustments.svg": [
		92689,
		2689
	],
	"./alarm-classification.svg": [
		61047,
		1047
	],
	"./alarm-reception.svg": [
		48526,
		8526
	],
	"./annotation.svg": [
		37276,
		7276
	],
	"./arc_admin.svg": [
		99077,
		9077
	],
	"./archive.svg": [
		40323,
		323
	],
	"./arrow-circle-down.svg": [
		5624,
		5624
	],
	"./arrow-circle-in.svg": [
		20385,
		385
	],
	"./arrow-circle-left.svg": [
		33559,
		3559
	],
	"./arrow-circle-out.svg": [
		18512,
		8512
	],
	"./arrow-circle-right.svg": [
		80818,
		818
	],
	"./arrow-circle-up.svg": [
		75019,
		5019
	],
	"./arrow-down.svg": [
		40207,
		207
	],
	"./arrow-left.svg": [
		74096,
		4096
	],
	"./arrow-narrow-down.svg": [
		31551,
		1551
	],
	"./arrow-narrow-left.svg": [
		73088,
		3088
	],
	"./arrow-narrow-right.svg": [
		53839,
		3839
	],
	"./arrow-narrow-up.svg": [
		63792,
		3792
	],
	"./arrow-right.svg": [
		80991,
		991
	],
	"./arrow-up.svg": [
		98400,
		8400
	],
	"./arrows-expand.svg": [
		95122,
		5122
	],
	"./at-symbol.svg": [
		54161,
		4161
	],
	"./backspace.svg": [
		83384,
		3384
	],
	"./badge-check.svg": [
		30759,
		759
	],
	"./ban.svg": [
		6222,
		6222
	],
	"./bars.svg": [
		24117,
		4117
	],
	"./beaker.svg": [
		11129,
		1129
	],
	"./bell.svg": [
		85516,
		5516
	],
	"./bitbucket.svg": [
		84606,
		4606
	],
	"./book-open.svg": [
		96213,
		6213
	],
	"./bookmark-alt.svg": [
		45913,
		5913
	],
	"./bookmark.svg": [
		15719,
		5719
	],
	"./briefcase.svg": [
		7789,
		7789
	],
	"./building.svg": [
		95763,
		5763
	],
	"./cake.svg": [
		81047,
		3428
	],
	"./calculator.svg": [
		33307,
		3307
	],
	"./calendar.svg": [
		36745,
		6745
	],
	"./calendar_available.svg": [
		7853,
		7853
	],
	"./calendar_unavailable.svg": [
		58218,
		8218
	],
	"./camera.svg": [
		14438,
		4438
	],
	"./cash.svg": [
		64442,
		4442
	],
	"./chart-bar.svg": [
		10117,
		117
	],
	"./chart-pie.svg": [
		91684,
		1684
	],
	"./chart-square-bar.svg": [
		19935,
		9935
	],
	"./chat-alt-2.svg": [
		95586,
		5586
	],
	"./chat-alt.svg": [
		32407,
		2407
	],
	"./chat.svg": [
		10701,
		701
	],
	"./check-circle.svg": [
		53790,
		3790
	],
	"./check.svg": [
		67553,
		7553
	],
	"./chevron-double-down.svg": [
		619,
		619
	],
	"./chevron-double-left.svg": [
		67596,
		7596
	],
	"./chevron-double-right.svg": [
		92435,
		2435
	],
	"./chevron-double-up.svg": [
		21508,
		1508
	],
	"./chevron-down.svg": [
		40693,
		693
	],
	"./chevron-left.svg": [
		73646,
		3646
	],
	"./chevron-right.svg": [
		20717,
		717
	],
	"./chevron-up.svg": [
		24186,
		4186
	],
	"./chip.svg": [
		94825,
		4825
	],
	"./clipboard-check.svg": [
		31528,
		1528
	],
	"./clipboard-copy.svg": [
		48167,
		8167
	],
	"./clipboard-list.svg": [
		45144,
		5144
	],
	"./clipboard.svg": [
		85975,
		5975
	],
	"./clock.svg": [
		60779,
		779
	],
	"./cloud-download.svg": [
		53531,
		3531
	],
	"./cloud-upload.svg": [
		516,
		516
	],
	"./cloud.svg": [
		66382,
		6382
	],
	"./code.svg": [
		55048,
		5048
	],
	"./cog.svg": [
		57700,
		7700
	],
	"./collapse_menu.svg": [
		73712,
		3712
	],
	"./collection.svg": [
		95855,
		5855
	],
	"./color-swatch.svg": [
		30769,
		769
	],
	"./compass.svg": [
		55297,
		5297
	],
	"./credit-card.svg": [
		53107,
		3107
	],
	"./cube-transparent.svg": [
		47469,
		7469
	],
	"./cube.svg": [
		26460,
		6460
	],
	"./currency-bangladeshi.svg": [
		84117,
		6498
	],
	"./currency-dollar.svg": [
		94813,
		4813
	],
	"./currency-euro.svg": [
		13064,
		3064
	],
	"./currency-pound.svg": [
		75564,
		3183
	],
	"./currency-rupee.svg": [
		53578,
		3578
	],
	"./currency-yen.svg": [
		77493,
		7493
	],
	"./cursor-click.svg": [
		23310,
		3310
	],
	"./database.svg": [
		50588,
		588
	],
	"./desktop-computer.svg": [
		82817,
		2817
	],
	"./device-mobile.svg": [
		61272,
		1272
	],
	"./device-tablet.svg": [
		76422,
		6422
	],
	"./document-add.svg": [
		62118,
		2118
	],
	"./document-download.svg": [
		58105,
		8105
	],
	"./document-duplicate.svg": [
		752,
		752
	],
	"./document-remove.svg": [
		25361,
		5361
	],
	"./document-report.svg": [
		94891,
		4891
	],
	"./document-search.svg": [
		60685,
		685
	],
	"./document-text.svg": [
		68184,
		8184
	],
	"./document.svg": [
		51864,
		1864
	],
	"./dots-circle-horizontal.svg": [
		95649,
		5649
	],
	"./dots-horizontal.svg": [
		60576,
		576
	],
	"./dots-vertical.svg": [
		57894,
		7894
	],
	"./double-dots-vertical.svg": [
		46676,
		6676
	],
	"./download.svg": [
		26663,
		6663
	],
	"./dropdownArrow.svg": [
		96175,
		6175
	],
	"./duplicate.svg": [
		30862,
		862
	],
	"./emoji-happy.svg": [
		94398,
		4398
	],
	"./emoji-sad.svg": [
		61472,
		1472
	],
	"./excel_logo.svg": [
		16602,
		6602
	],
	"./exclamation-circle.svg": [
		22467,
		2467
	],
	"./exclamation.svg": [
		93798,
		3798
	],
	"./expand_menu.svg": [
		95963,
		5963
	],
	"./external-link.svg": [
		2055,
		2055
	],
	"./eye-off.svg": [
		60170,
		170
	],
	"./eye.svg": [
		55674,
		5674
	],
	"./fast-forward.svg": [
		77517,
		7517
	],
	"./film.svg": [
		43357,
		3357
	],
	"./filter.svg": [
		43569,
		3569
	],
	"./finger-print.svg": [
		1490,
		1490
	],
	"./fire.svg": [
		14047,
		4047
	],
	"./flag.svg": [
		53113,
		3113
	],
	"./folder-add.svg": [
		44141,
		4141
	],
	"./folder-download.svg": [
		55788,
		5788
	],
	"./folder-open.svg": [
		91268,
		1268
	],
	"./folder-remove.svg": [
		28820,
		8820
	],
	"./folder.svg": [
		86395,
		6395
	],
	"./gift.svg": [
		78081,
		8081
	],
	"./globe-alt.svg": [
		69936,
		9936
	],
	"./globe.svg": [
		90994,
		994
	],
	"./hand.svg": [
		95708,
		5708
	],
	"./hashtag.svg": [
		96905,
		6905
	],
	"./heart-alive.svg": [
		14709,
		4709
	],
	"./heart-deceased.svg": [
		46136,
		6136
	],
	"./heart.svg": [
		34789,
		4789
	],
	"./hierarchy.svg": [
		48772,
		8772
	],
	"./history.svg": [
		97793,
		7793
	],
	"./home.svg": [
		86174,
		6174
	],
	"./identification.svg": [
		19957,
		9957
	],
	"./inbox-in.svg": [
		81299,
		1299
	],
	"./inbox.svg": [
		94029,
		4029
	],
	"./information-circle.svg": [
		98168,
		8168
	],
	"./json_logo.svg": [
		19909,
		9909
	],
	"./key-holder.svg": [
		53963,
		3963
	],
	"./key-role.svg": [
		30889,
		889
	],
	"./key.svg": [
		18248,
		8248
	],
	"./library.svg": [
		11596,
		1596
	],
	"./light-bulb.svg": [
		38955,
		8955
	],
	"./lightning-bolt.svg": [
		12805,
		2805
	],
	"./link.svg": [
		43119,
		3119
	],
	"./location-marker.svg": [
		63074,
		3074
	],
	"./lock-closed.svg": [
		23395,
		3395
	],
	"./lock-open.svg": [
		68607,
		8607
	],
	"./login.svg": [
		79058,
		9058
	],
	"./logout.svg": [
		89861,
		9861
	],
	"./mail-open.svg": [
		17123,
		7123
	],
	"./mail.svg": [
		71814,
		1814
	],
	"./map.svg": [
		80791,
		791
	],
	"./marker.svg": [
		94881,
		4881
	],
	"./maximize.svg": [
		46337,
		6337
	],
	"./menu-alt-1.svg": [
		9438,
		9438
	],
	"./menu-alt-2.svg": [
		21533,
		1533
	],
	"./menu-alt-3.svg": [
		92988,
		2988
	],
	"./menu-alt-4.svg": [
		36995,
		6995
	],
	"./menu.svg": [
		84434,
		4434
	],
	"./microphone.svg": [
		34455,
		4455
	],
	"./minimize.svg": [
		44787,
		4787
	],
	"./minus-circle.svg": [
		38294,
		8294
	],
	"./minus.svg": [
		33497,
		3497
	],
	"./moon.svg": [
		89628,
		9628
	],
	"./music-note.svg": [
		6621,
		6621
	],
	"./new-window.svg": [
		69500,
		9500
	],
	"./next.svg": [
		84396,
		4396
	],
	"./nok.svg": [
		85781,
		5781
	],
	"./office-building.svg": [
		40424,
		424
	],
	"./paper-airplane.svg": [
		98170,
		8170
	],
	"./paper-clip.svg": [
		30154,
		154
	],
	"./pause.svg": [
		20651,
		651
	],
	"./pencil-alt.svg": [
		53758,
		3758
	],
	"./pencil.svg": [
		22120,
		2120
	],
	"./phone-incoming.svg": [
		63222,
		3222
	],
	"./phone-missed-call.svg": [
		34658,
		4658
	],
	"./phone-outgoing.svg": [
		57204,
		7204
	],
	"./phone.svg": [
		85049,
		5049
	],
	"./photograph.svg": [
		35047,
		5047
	],
	"./play.svg": [
		22757,
		2757
	],
	"./plus-circle.svg": [
		73224,
		3224
	],
	"./plus.svg": [
		36491,
		6491
	],
	"./presentation-chart-bar.svg": [
		96896,
		6896
	],
	"./presentation-chart-line.svg": [
		43959,
		3959
	],
	"./previous.svg": [
		75972,
		5972
	],
	"./priceDollarIcon.svg": [
		75071,
		5071
	],
	"./printer.svg": [
		73657,
		3657
	],
	"./puzzle.svg": [
		56235,
		6235
	],
	"./qrcode.svg": [
		1657,
		1657
	],
	"./question-mark-circle.svg": [
		14108,
		4108
	],
	"./receipt-refund.svg": [
		7620,
		7620
	],
	"./receipt-tax.svg": [
		18245,
		8245
	],
	"./refresh.svg": [
		33264,
		3264
	],
	"./reply.svg": [
		47753,
		7753
	],
	"./reports-illustration.svg": [
		97819,
		7819
	],
	"./reset.svg": [
		52300,
		2300
	],
	"./rewind.svg": [
		94182,
		4182
	],
	"./rss.svg": [
		73749,
		3749
	],
	"./save-as.svg": [
		27893,
		7893
	],
	"./save.svg": [
		56660,
		6660
	],
	"./scale.svg": [
		15983,
		5983
	],
	"./scissors.svg": [
		60966,
		966
	],
	"./search-circle.svg": [
		19796,
		9796
	],
	"./search.svg": [
		36279,
		6279
	],
	"./selector.svg": [
		69360,
		9360
	],
	"./server.svg": [
		20738,
		738
	],
	"./share.svg": [
		36004,
		6004
	],
	"./shield-check.svg": [
		86503,
		6503
	],
	"./shield-exclamation.svg": [
		70804,
		804
	],
	"./shopping-bag.svg": [
		17846,
		7846
	],
	"./shopping-cart.svg": [
		90166,
		166
	],
	"./skyresponse.svg": [
		96839,
		6839
	],
	"./skyresponse_color.svg": [
		13427,
		3427
	],
	"./sort-ascending.svg": [
		23662,
		3662
	],
	"./sort-descending.svg": [
		44534,
		4534
	],
	"./sparkles.svg": [
		21290,
		1290
	],
	"./speakerphone.svg": [
		76978,
		6978
	],
	"./star.svg": [
		52815,
		2815
	],
	"./status-offline.svg": [
		92815,
		5196
	],
	"./status-online.svg": [
		36227,
		6227
	],
	"./stop.svg": [
		18139,
		8139
	],
	"./structure.svg": [
		27790,
		7790
	],
	"./sun.svg": [
		38639,
		8639
	],
	"./super-user.svg": [
		51212,
		1212
	],
	"./support.svg": [
		97172,
		7172
	],
	"./switch-horizontal.svg": [
		43936,
		3936
	],
	"./switch-vertical.svg": [
		68070,
		8070
	],
	"./table.svg": [
		86201,
		6201
	],
	"./tag.svg": [
		69445,
		9445
	],
	"./template.svg": [
		31189,
		1189
	],
	"./terminal.svg": [
		87023,
		7023
	],
	"./terminate.svg": [
		44776,
		4776
	],
	"./thumb-down.svg": [
		24346,
		4346
	],
	"./thumb-up.svg": [
		9257,
		9257
	],
	"./ticket.svg": [
		88675,
		8675
	],
	"./translate.svg": [
		14075,
		4075
	],
	"./trash.svg": [
		5595,
		5595
	],
	"./trending-down.svg": [
		43061,
		3061
	],
	"./trending-up.svg": [
		52570,
		2570
	],
	"./truck.svg": [
		70668,
		668
	],
	"./upload.svg": [
		6184,
		6184
	],
	"./user-accepted.svg": [
		99012,
		9012
	],
	"./user-add.svg": [
		88672,
		8672
	],
	"./user-deactivated.svg": [
		75923,
		5923
	],
	"./user-group.svg": [
		73776,
		3776
	],
	"./user-remove.svg": [
		65347,
		5347
	],
	"./user.svg": [
		22698,
		2698
	],
	"./users.svg": [
		58613,
		8613
	],
	"./variable.svg": [
		61091,
		1091
	],
	"./vector.svg": [
		58522,
		8522
	],
	"./video-camera.svg": [
		70264,
		264
	],
	"./view-boards.svg": [
		63706,
		3706
	],
	"./view-grid-add.svg": [
		14759,
		4759
	],
	"./view-grid.svg": [
		30418,
		8037
	],
	"./view-list.svg": [
		97129,
		7129
	],
	"./volume-off.svg": [
		54653,
		4653
	],
	"./volume-up.svg": [
		861,
		861
	],
	"./wifi.svg": [
		77460,
		7460
	],
	"./x-circle.svg": [
		40406,
		406
	],
	"./x.svg": [
		24569,
		4569
	],
	"./zoom-in.svg": [
		90878,
		878
	],
	"./zoom-out.svg": [
		33433,
		3433
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 94082;
module.exports = webpackAsyncContext;